var _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMa = function SvgMa(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_21602_7857",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#4171CF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_21602_7857)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#C1272D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5257 3.61803L11.8885 7.81234H16.2987H18L16.6236 8.81234L13.0557 11.4046L14.4185 15.5989L14.9443 17.2169L13.5679 16.2169L10 13.6247L6.43211 16.2169L5.05573 17.2169L5.58146 15.5989L6.94427 11.4046L3.37638 8.81234L2 7.81234H3.7013H8.11146L9.47427 3.61803L10 2L10.5257 3.61803ZM12.051 8.81234H14.9223L12.5994 10.5001L12.051 8.81234ZM10.8874 7.96732L10 5.23607L9.11256 7.96732L10.8874 7.96732ZM7.95004 8.81234H5.07768L7.40147 10.5007L7.95004 8.81234ZM7.8454 11.8672L6.95784 14.5989L9.28149 12.9106L7.8454 11.8672ZM10.719 12.911L13.0422 14.5989L12.1548 11.8679L10.719 12.911ZM11.0499 8.96732L11.6985 10.9634L10.0005 12.197L8.3026 10.9634L8.95115 8.96732L11.0499 8.96732Z",
    fill: "#006233"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMa);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ma.4bd898b613ae5ab7975e64829a763ce7.svg";